import script from "./RhView.vue?vue&type=script&setup=true&lang=js"
export * from "./RhView.vue?vue&type=script&setup=true&lang=js"

import "./RhView.vue?vue&type=style&index=0&id=06d4e756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d4e756"]])

export default __exports__